

if (!customElements.get('product-form-snippet')) {
  customElements.define('product-form-snippet', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('.form-sub-product');
      this.button =  this.form.querySelector('.sub-product-button');
      this.button.addEventListener('click', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      let formDataArr = [];
      const customProducts = document.querySelectorAll('.product__info-sub-product');
      const mainProductID = document.querySelector('.main-product-variant-id').value;

      const subProducts = document.querySelectorAll('.innerproduct__wrap input:checked');

      formDataArr.push ({
        'id': mainProductID,
        'quantity': 1,
        'properties': {
          '_isSubProduct': 'isSubProduct'
        }
      })

      customProducts.forEach(product => {
        const productID =  product.querySelector('[name="id"]').value;
        const innerFiledHolder = product.querySelector('.variant-field-info:not(.visually-hidden)');
        let innerFiledValue = '';
        let innerFiledTitle = '';

        if(innerFiledHolder != null) {
          innerFiledValue = innerFiledHolder.querySelector('.variant-properties').value;
          innerFiledTitle = innerFiledHolder.querySelector('.variant-field-info--title').innerText;
        }

        if(productID.length > 0) {

          let productArr = {
            'id': productID,
            'quantity': 1,
            'properties': {
              '_hasSubProduct': 'hasSubProduct'
            }
          }

          if(innerFiledHolder != null && innerFiledValue.length > 0) {
            productArr = {
              'id': productID,
              'quantity': 1,
              'properties': {
                '_hasSubProduct': 'hasSubProduct',
                'addInfo' : `${innerFiledTitle}: ${innerFiledValue}`
              }
            }
          }

          formDataArr.push(productArr)
        }
      });

      if(subProducts.length > 0) {
        subProducts.forEach((product) => {
          const variantID = product.dataset.variantid;
          const subproductArr = {
            'id': variantID,
            'quantity': 1
          }
          formDataArr.push(subproductArr)
        });
      }

      let formData = {
        'items': formDataArr,
        'sections': this.cart.getSectionsToRender().map((section) => section.id),
        'sections_url': window.location.pathname
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          this.cart.renderContents(response);

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
